import React, { useEffect, useState } from "react"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { Slide } from "react-toastify"
import { withRouter } from "react-router-dom"
import PropTypes from "prop-types"
import Select from "react-select"
//i18n
import { withTranslation } from "react-i18next"
//Import Date Picker
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import API from "../../api"
import { Button, Col, Form, Input, Label, Row } from "reactstrap"
import getDay from "date-fns/getDay"

const AddRattrapage = props => {
  const [date, setDate] = useState()
  const [quart, setQuart] = useState([])
  const [selectQuart, setSelectQuart] = useState("")
  const [type, setType] = useState([])
  const [selectType, setSelectType] = useState("")
  const [groupe, setGroupe] = useState([])
  const [selectGroupe, setSelectGroupe] = useState("")
  const [matiere, setMatiere] = useState([])
  const [selectMatiere, setSelectMatiere] = useState("")
  const [jourId, setJourId] = useState("")
  const [enseignant, setEnseignant] = useState([])
  const [selectEnseignant, setSelectEnseignant] = useState("")
  const [salle, setSalle] = useState([])
  const [selectSalle, setSelectSalle] = useState("")
  const [semestre, setSemestre] = useState([
    { value: 1, label: "Semestre 1" },
    { value: 2, label: "Semestre 2" },
  ])
  const [selectSemestre, setSelectSemestre] = useState("")
  const [nbrHeureSeance, setNbrHeureSeance] = useState([
    { value: 2, label: "1h" },
    { value: 3, label: "1h:30" },
    { value: 4, label: "2h" },
    { value: 5, label: "2h:30" },
    { value: 6, label: "3h" },
    { value: 7, label: "3h:30" },
    { value: 8, label: "4h" },
  ])
  const [selectNbrHeureSeance, setSelectNbrHeureSeance] = useState("")
  const [nbrHeure, setNbrHeure] = useState("")
  const [col, setCol] = useState(6)
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var annee_id = userAuthScolarite.user.annee_id
  var user_id = userAuthScolarite.user.id

  useEffect(async () => {
    const res = await API.get("enseignant/select").then(res => {
      setEnseignant(res.data.select_enseignant)
    })
    const resQ = await API.get("quart/select").then(resQ => {
      setQuart(resQ.data.Quart)
    })
  }, [])

  const isWeekday = date => {
    const day = getDay(date)
    return day !== 0
  }

  const getTypeMatiere = async e => {
    setSelectSemestre(e)

    setSelectQuart("")
    setSelectType("")
    setSelectMatiere("")
    setCol(6)
    setSelectNbrHeureSeance("")
    setSelectGroupe("")
    setSelectSalle("")
    setNbrHeure("")
    const res = await API.post("emploi/get_type_matiere", {
      enseignant_id: selectEnseignant.value,
      semestre_id: e.value,
      annee_id,
    }).then(res => {
      setType(res.data.emploi)
    })
  }

  const getQuart = e => {
    setSelectQuart(e)
    setSelectType("")
    setSelectMatiere("")
    setCol(6)
    setSelectNbrHeureSeance("")
    setNbrHeure("")
    setSelectGroupe("")
    setSelectSalle("")
  }
  const getEnseignant = e => {
    setSelectEnseignant(e)
    setSelectSemestre("")

    setSelectQuart("")
    setSelectType("")
    setSelectMatiere("")
    setCol(6)
    setSelectNbrHeureSeance("")
    setSelectGroupe("")
    setSelectSalle("")
    setNbrHeure("")
  }

  const getDay1 = async e => {
    setDate(e)
    setSelectQuart("")
    setSelectType("")
    setSelectMatiere("")
    setSelectGroupe("")
    setSelectSalle("")
    // convert date début
    let date = e
    let month = "" + (date.getMonth() + 1)
    let day = "" + date.getDate()
    let year = date.getFullYear()
    if (month.length < 2) month = "0" + month
    if (day.length < 2) day = "0" + day
    let convertDate = [year, month, day].join("-")
    const res = await API.post("quart/get_date", {
      date: convertDate,
    }).then(res => {
      setJourId(res.data.Date)
    })
  }

  const getMatiere = async e => {
    setSelectType(e)
    setSelectMatiere("")
    setCol(6)
    setSelectNbrHeureSeance("")
    setNbrHeure("")
    setSelectGroupe("")
    setSelectSalle("")
    const res = await API.post("emploi/get_matiere", {
      type: e.value,
      enseignant_id: selectEnseignant.value,
      semestre_id: selectSemestre.value,
      annee_id,
    }).then(res => {
      setMatiere(res.data.matieres)
    })
  }

  const getGroupe = async e => {
    setSelectMatiere(e)
    setCol(6)
    setSelectNbrHeureSeance("")
    setNbrHeure("")
    setSelectGroupe("")
    setSelectSalle("")
    const resG = await API.post("emploi/get_group", {
      quart_id: selectQuart.value,
      jour_id: jourId,
      quan: 0,
      matiere_id: e.value,
      type: selectType.value,
      semestre_id: selectSemestre.value,
      enseignant_id: selectEnseignant.value,
      annee_id,
    }).then(resG => {
      setGroupe(resG.data.groups)
    })
    const res = await API.post("seance/get_heure_by_type", {
      matiere_id: e.value,
      type: selectType.value,
    }).then(res => {
      setNbrHeure(res.data.nb_heure)
      if (res.data.nb_heure >= 42) {
        setCol(3)
      } else {
        setCol(6)
      }
    })
  }

  const getSalle = async e => {
    setSelectGroupe(e)
    setSelectSalle("")
    const resS = await API.post("emploi/get_salle", {
      quart_id: selectQuart.value,
      jour_id: jourId,
      semestre_id: selectSemestre.value,
      quan: 0,
      annee_id,
      type: selectType.value,
      matiere_id: selectMatiere.value,
    }).then(resS => {
      setSalle(resS.data.salles)
    })
  }
  const save = async () => {
    if (!selectEnseignant) {
      return toast.error("⛔ Enseignant obligatoire !", { containerId: "A" })
    }
    if (!selectSemestre) {
      return toast.error("⛔ Semestre obligatoire !", { containerId: "A" })
    }
    if (!date) {
      return toast.error("⛔ Date obligatoire !", { containerId: "A" })
    }
    if (!selectQuart) {
      return toast.error("⛔ Quart obligatoire !", { containerId: "A" })
    }
    if (!selectType) {
      return toast.error("⛔ Type obligatoire !", { containerId: "A" })
    }
    if (!selectMatiere) {
      return toast.error("⛔ Matière obligatoire !", { containerId: "A" })
    }
    if (!selectGroupe) {
      return toast.error("⛔ Groupe obligatoire !", { containerId: "A" })
    }
    if (!selectSalle) {
      return toast.error("⛔ Salle obligatoire !", { containerId: "A" })
    }
    const dateRatt = new Date(date)
    const year = dateRatt.getFullYear()
    const month = String(dateRatt.getMonth() + 1).padStart(2, "0")
    const day = String(dateRatt.getDate()).padStart(2, "0")
    const convertDate = `${year}-${month}-${day}`
    try {
      if (nbrHeure >= 42 && !selectNbrHeureSeance) {
        return toast.error("⛔ Nbr heure séance obligatoire !", { containerId: "A" });
      }
      const resS = await API.post("avis/rattrapage/store", {
        date: convertDate,
        enseignant_id: selectEnseignant?.value,
        jour_id: jourId,
        quart_id: selectQuart?.value,
        matiere_id: selectMatiere?.value,
        group_id: selectGroupe,
        salle_id: selectSalle?.value,
        type: selectType?.value,
        semestre_id: selectSemestre?.value,
        quan: 0,
        annee_id,
        user_id,
        nbrHeureSeance: selectNbrHeureSeance ? selectNbrHeureSeance.value : 0,
      });
      switch (resS.data.errNum) {
        case "400":
        case "401":
        case "402":
        case "403":
        case "404":
        case "405":
        case "406":
        case "407":
        case "408":
        case "409":
          return toast.error("⛔ " + resS.data.msg, { containerId: "A" });
          break;
        default:
          props.setSection(1);
          break;
      }
    } catch (error) {
      toast.error("Problème lors de l'insertion !", { containerId: "A" });
    }
  }

  return (
    <React.Fragment>
      <Row>
        <Form>
          <Row>
            <Col lg="6">
              <div className="mb-3">
                <Label for="basicpill-firstname-input1">
                  {props.t("Enseignant")}
                </Label>
                <Select
                  options={enseignant}
                  isSearchable={true}
                  value={selectEnseignant}
                  onChange={e => getEnseignant(e)}
                />
              </div>
            </Col>
            <Col lg="6">
              <div className="mb-3">
                <Label for="basicpill-firstname-input1">
                  {props.t("Semestre")}
                </Label>
                <Select
                  options={semestre}
                  isSearchable={true}
                  value={selectSemestre}
                  onChange={e => getTypeMatiere(e)}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg="6">
              <div className="mb-3">
                <Label for="basicpill-firstname-input1">
                  {props.t("Date")}
                  <span style={{ color: "red", paddingLeft: "5px" }}>*</span>
                </Label>
                <DatePicker
                  selected={date}
                  filterDate={isWeekday}
                  className="form-control ddate"
                  dateFormat="dd/MM/yyyy"
                  onChange={e => getDay1(e)}
                />
              </div>
            </Col>
            <Col lg="6">
              <div className="mb-3">
                <Label for="basicpill-firstname-input1">
                  {props.t("Quart")}
                </Label>
                <Select
                  options={quart}
                  isSearchable={true}
                  value={selectQuart}
                  onChange={e => getQuart(e)}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg="6">
              <div className="mb-3">
                <Label for="basicpill-firstname-input1">Type</Label>
                <Select
                  options={type}
                  isSearchable={true}
                  value={selectType}
                  onChange={e => getMatiere(e)}
                />
              </div>
            </Col>
            <Col lg={col}>
              <div className="mb-3">
                <Label for="basicpill-firstname-input1">Matiere</Label>
                <Select
                  options={matiere}
                  isSearchable={true}
                  value={selectMatiere}
                  onChange={e => getGroupe(e)}
                />
              </div>
            </Col>
            {nbrHeure >= 42 ? (
              <Col lg={col}>
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    Nbr heure seance
                  </Label>
                  <Select
                    options={nbrHeureSeance}
                    isSearchable={true}
                    value={selectNbrHeureSeance}
                    onChange={e => setSelectNbrHeureSeance(e)}
                  />
                </div>
              </Col>
            ) : null}
          </Row>
          <Row>
            <Col lg="6">
              <div className="mb-3">
                <Label for="basicpill-firstname-input1">Groupe</Label>
                <Select
                  options={groupe}
                  isSearchable={true}
                  value={selectGroupe}
                  onChange={e => getSalle(e)}
                  isMulti={true}
                />
              </div>
            </Col>
            <Col lg="6">
              <div className="mb-3">
                <Label for="basicpill-firstname-input1">Salle</Label>
                <Select
                  options={salle}
                  isSearchable={true}
                  value={selectSalle}
                  onChange={e => setSelectSalle(e)}
                />
              </div>
            </Col>
          </Row>
        </Form>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          {" "}
          <Col lg="6">
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
              className="text-center mt-4"
            >
              <Button
                type="button"
                color="warning"
                className="btn btn-warning  mb-2 me-2"
                onClick={props.back}
              >
                {props.t("Annuler")}
              </Button>
            </div>
          </Col>
          <Col lg="6">
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
              }}
              className="text-center mt-4"
            >
              <button type="button" className="btn btn-primary " onClick={save}>
                {props.t("Confirmer")}
              </button>
            </div>
          </Col>
        </div>
      </Row>
      <ToastContainer
        transition={Slide}
        enableMultiContainer
        containerId={"A"}
        position={toast.POSITION.TOP_RIGHT}
        autoClose={2500}
      />
    </React.Fragment>
  )
}
export default withRouter(withTranslation()(AddRattrapage))
AddRattrapage.propTypes = {
  history: PropTypes.object,
  back: PropTypes.object,
  setSection: PropTypes.object,
  t: PropTypes.any,
}
